import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BaseBackResponse } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.authorization}users/setUserProfilesToUser/${COMMON_QUERY_PARAMS.USER_ID}`;

export interface SetUserArgs {
  userId: string;
  sellerId: string;
  userProfileIds: string[];
  entityType?: string;
}

export const setUserProfilesToUserRequest = (
  payload: SetUserArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.USER_ID, payload.userId),
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: {
      sellerId: payload.sellerId,
      userProfileIds: payload.userProfileIds,
      entityType: payload.entityType ?? 'Seller',
    },
  },
});

export default async function setUserProfilesToUser(
  payload: SetUserArgs,
): Promise<BaseBackResponse> {
  try {
    return await executeQuery(setUserProfilesToUserRequest(payload));
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
